export enum IconBlock {
  Root = 'Icon',
}

export enum IconModifier {
  Hover = 'hover',
}
